import { SportDataGatewayStreamObserver } from "../../models";
import { SportDataGateway } from "../SportDataGateway";
import { entities } from "sbtech-sports-data-api-client";
//DO NOT USE THIS COMPONENT USE SPORTSDATAGATEWAY.ts directly THIS WILL NOT WORK WITH MORE BLOCKS ON THE PAGE
/**
 * SportDataGatewayStream class provides interface for communication between sports data gateway and blocks through sports data client.
 */
export class SportDataGatewayStream {
    /**
    * Creates an instance of SportDataGatewayStream
    */
    /* istanbul ignore next */
    constructor() {
        this.subscriptions = [];
        this.messageHandlers = [];
        for (let key in entities.EntityType) {
            if (isNaN(Number(key))) {
                this.subscriptions[key] = [];
                this.messageHandlers[key] = this.onMessageHandler.bind(this, key);
            }
        }
        window.addEventListener("unload", this.deactivate.bind(this));
    }
    /**
     * Activate method does nothing and has beed added for consistency
    */
    activate() {
    }
    /**
     * Subscribes updates from sports data API for entity of type "Event".
     * @param {SportDataGatewayStreamQueryParams} entityType needed so you can get all update for this type.
     * @param {SportDataGatewayStreamQueryParams} id unique identifier
     * @param {SportDataGatewayStreamQueryParams} queryInfo containing the query and the callback for the subscribed events.
     */
    /* istanbul ignore next */
    subscribeForEvents(queryParams) {
        if (!this.gateway) {
            this.gateway = this.initSportDataGateway();
        }
        let queryInfo = queryParams.queryInfo;
        let onBlockMessageHandler = queryInfo.onMessageHandler;
        let entityType = entities.EntityType[queryParams.entityType];
        queryInfo.onMessageHandler = this.messageHandlers[entityType];
        let observer = this.gateway.subscribeForEvents(queryInfo);
        let sportDataGatewayStreamObserver = new SportDataGatewayStreamObserver(queryParams.id, observer, onBlockMessageHandler);
        this.subscriptions[entityType].push(sportDataGatewayStreamObserver);
    }
    /**
     * Subscribes updates from sports data API for entity of type "Market".
     * @param {SportDataGatewayStreamQueryParams} entityType needed so you can get all update for this type.
     * @param {SportDataGatewayStreamQueryParams} id unique identifier
     * @param {SportDataGatewayStreamQueryParams} queryInfo containing the query and the callback for the subscribed Markets.
     */
    /* istanbul ignore next */
    subscribeForMarkets(queryParams) {
        if (!this.gateway) {
            this.gateway = this.initSportDataGateway();
        }
        let queryInfo = queryParams.queryInfo;
        let onBlockMessageHandler = queryInfo.onMessageHandler;
        let entityType = entities.EntityType[queryParams.entityType];
        queryInfo.onMessageHandler = this.messageHandlers[entityType];
        let observer = this.gateway.subscribeForMarkets(queryInfo);
        let sportDataGatewayStreamObserver = new SportDataGatewayStreamObserver(queryParams.id, observer, onBlockMessageHandler);
        this.subscriptions[entityType].push(sportDataGatewayStreamObserver);
    }
    /**
     * Subscribes updates from sports data API for entity of type "League".
     * @param {SportDataGatewayStreamQueryParams} entityType needed so you can get all update for this type.
     * @param {SportDataGatewayStreamQueryParams} id unique identifier
     * @param {SportDataGatewayStreamQueryParams} queryInfo containing the query and the callback for the subscribed Leagues.

     */
    /* istanbul ignore next */
    subscribeForLeagues(queryParams) {
        if (!this.gateway) {
            this.gateway = this.initSportDataGateway();
        }
        let queryInfo = queryParams.queryInfo;
        let onBlockMessageHandler = queryInfo.onMessageHandler;
        let entityType = entities.EntityType[queryParams.entityType];
        queryInfo.onMessageHandler = this.messageHandlers[entityType];
        let observer = this.gateway.subscribeForLeagues(queryInfo);
        let sportDataGatewayStreamObserver = new SportDataGatewayStreamObserver(queryParams.id, observer, onBlockMessageHandler);
        this.subscriptions[entityType].push(sportDataGatewayStreamObserver);
    }
    /**
     * Subscribes updates from sports data API for entity of type "Region".
     * @param {SportDataGatewayStreamQueryParams} entityType needed so you can get all update for this type.
     * @param {SportDataGatewayStreamQueryParams} id unique identifier
     * @param {SportDataGatewayStreamQueryParams} queryInfo containing the query and the callback for the subscribed Regions.
     */
    /* istanbul ignore next */
    subscribeForRegions(queryParams) {
        if (!this.gateway) {
            this.gateway = this.initSportDataGateway();
        }
        let queryInfo = queryParams.queryInfo;
        let onBlockMessageHandler = queryInfo.onMessageHandler;
        let entityType = entities.EntityType[queryParams.entityType];
        queryInfo.onMessageHandler = this.messageHandlers[entityType];
        let observer = this.gateway.subscribeForRegions(queryInfo);
        let sportDataGatewayStreamObserver = new SportDataGatewayStreamObserver(queryParams.id, observer, onBlockMessageHandler);
        this.subscriptions[entityType].push(sportDataGatewayStreamObserver);
    }
    /**
     * Subscribes updates from sports data API for entity of type "Sport".
     * @param {SportDataGatewayStreamQueryParams} entityType needed so you can get all update for this type.
     * @param {SportDataGatewayStreamQueryParams} id unique identifier
     * @param {SportDataGatewayStreamQueryParams} queryInfo containing the query and the callback for the subscribed Sports.
     */
    /* istanbul ignore next */
    subscribeForSports(queryParams) {
        if (!this.gateway) {
            this.gateway = this.initSportDataGateway();
        }
        let queryInfo = queryParams.queryInfo;
        let onBlockMessageHandler = queryInfo.onMessageHandler;
        let entityType = entities.EntityType[queryParams.entityType];
        queryInfo.onMessageHandler = this.messageHandlers[entityType];
        let observer = this.gateway.subscribeForSports(queryInfo);
        let sportDataGatewayStreamObserver = new SportDataGatewayStreamObserver(queryParams.id, observer, onBlockMessageHandler);
        this.subscriptions[entityType].push(sportDataGatewayStreamObserver);
    }
    /**
    *Unsubscribes for updates for specific type
    * @param {entityType} type of entity to unsubcribe (exaple: Market,Sport,Event etc.)
    * @param {id} unique identifier used during subcription.
    **/
    unsubscribe(entityType, id) {
        let indexToRemove = this.subscriptions[entities.EntityType[entityType]].findIndex((sportDataGatewayStreamObserver) => sportDataGatewayStreamObserver.id === id);
        if (indexToRemove >= 0) {
            this.subscriptions[entities.EntityType[entityType]][indexToRemove].observer.unsubscribe();
            this.subscriptions[entities.EntityType[entityType]].splice(indexToRemove, 1);
        }
    }
    /**
    * Deactivate method removes all subscriptions
    */
    /* istanbul ignore next */
    deactivate() {
        this.subscriptions.forEach(subscriptionArray => {
            subscriptionArray.forEach(subscription => {
                subscription.observer.unsubscribe();
            });
        });
        this.subscriptions = [];
    }
    /**
     * Get subscriptions by type
     * @param {entities.EntityType} type predefined type of subscription entity
    */
    /* istanbul ignore next */
    getSubscriptionsByType(type) {
        return this.subscriptions[entities.EntityType[type]];
    }
    /**
     * General handler for updates from sports data API
     * @param {entities.EntityType} type predefined type of subscription entity
     * @param {any} response received response from SportData API
    */
    /* istanbul ignore next */
    onMessageHandler(type, response) {
        // For each subscriber from specified entity - call it's success callback
        this.subscriptions[type].forEach((streamObserver) => {
            streamObserver.onMessageHandler(response);
        });
    }
    /**
    * Create new instance of SportDataGateway
    */
    /* istanbul ignore next */
    initSportDataGateway() {
        return new SportDataGateway();
    }
}
export const SportDataGatewayStreamInstance = new SportDataGatewayStream();
//# sourceMappingURL=SportDataGatewayStream.js.map